import { useTranslation } from 'next-i18next';
import CTABanner1 from './CTABanner1';

export const CTABannerWebsiteEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerWebsite.title')}
      description={t('ctaBannerWebsite.description')}
      btnText={t('ctaBannerWebsite.btn')}
      url="https://bridebook.com/uk/wedding-website"
    />
  );
};

export const CTABannerBudgetEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerBudget.title')}
      description={t('ctaBannerBudget.description')}
      btnText={t('ctaBannerBudget.btn')}
      url="https://bridebook.com/uk/wedding-planning-tools/budget"
    />
  );
};

export const CTABannerChecklistEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerChecklist.title')}
      description={t('ctaBannerChecklist.description')}
      btnText={t('ctaBannerChecklist.btn')}
      url="https://bridebook.com/uk/wedding-planning-tools/checklist"
    />
  );
};

export const CTABannerGuestlistEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerGuestlist.title')}
      description={t('ctaBannerGuestlist.description')}
      btnText={t('ctaBannerGuestlist.btn')}
      url="https://bridebook.com/uk/wedding-planning-tools/guestlist"
    />
  );
};

export const CTABannerVisionEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerVision.title')}
      description={t('ctaBannerVision.description')}
      btnText={t('ctaBannerVision.btn')}
      url="https://bridebook.com/uk/scrapbook/inspiration"
    />
  );
};

export const CTABannerStationeryEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerStationery.title')}
      description={t('ctaBannerStationery.description')}
      btnText={t('ctaBannerStationery.btn')}
      url="https://invites.bridebook.com/"
    />
  );
};

export const CTABannerVenuesEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerVenues.title')}
      description={t('ctaBannerVenues.description')}
      btnText={t('ctaBannerVenues.btn')}
      url="https://bridebook.com/uk/search/wedding-venues"
    />
  );
};

export const CTABannerPhotogEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerPhotog.title')}
      description={t('ctaBannerPhotog.description')}
      btnText={t('ctaBannerPhotog.btn')}
      url="https://bridebook.com/uk/search/wedding-photographers"
    />
  );
};

export const CTABannerFloristsEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerFlorists.title')}
      description={t('ctaBannerFlorists.description')}
      btnText={t('ctaBannerFlorists.btn')}
      url="https://bridebook.com/uk/search/wedding-florists"
    />
  );
};

export const CTABannerVideoEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerVideo.title')}
      description={t('ctaBannerVideo.description')}
      btnText={t('ctaBannerVideo.btn')}
      url="https://bridebook.com/uk/search/wedding-videographers"
    />
  );
};

export const CTABannerCateringEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerCatering.title')}
      description={t('ctaBannerCatering.description')}
      btnText={t('ctaBannerCatering.btn')}
      url="https://bridebook.com/uk/search/wedding-catering"
    />
  );
};

export const CTABannerDressesEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerDresses.title')}
      description={t('ctaBannerDresses.description')}
      btnText={t('ctaBannerDresses.btn')}
      url="https://bridebook.com/uk/search/wedding-dress-accessories"
    />
  );
};

export const CTABannerEntertainmentEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerEntertainment.title')}
      description={t('ctaBannerEntertainment.description')}
      btnText={t('ctaBannerEntertainment.btn')}
      url="https://bridebook.com/uk/search/wedding-entertainment"
    />
  );
};

export const CTABannerCakesEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerCakes.title')}
      description={t('ctaBannerCakes.description')}
      btnText={t('ctaBannerCakes.btn')}
      url="https://bridebook.com/uk/search/wedding-cakes"
    />
  );
};

export const CTABannerHairBeautyEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerHairBeauty.title')}
      description={t('ctaBannerHairBeauty.description')}
      btnText={t('ctaBannerHairBeauty.btn')}
      url="https://bridebook.com/uk/search/wedding-beauty-hair-makeup"
    />
  );
};

export const CTABannerTransportEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerTransport.title')}
      description={t('ctaBannerTransport.description')}
      btnText={t('ctaBannerTransport.btn')}
      url="https://bridebook.com/uk/search/wedding-transport/"
    />
  );
};

export const CTABannerMusicEN = () => {
  const { t } = useTranslation('articles');
  return (
    <CTABanner1
      title={t('ctaBannerMusic.title')}
      description={t('ctaBannerMusic.description')}
      btnText={t('ctaBannerMusic.btn')}
      url="https://bridebook.com/uk/search/wedding-musicians-bands-djs"
    />
  );
};
